import { useTranslation } from 'react-i18next';
import Skill from '../Skill';
import SkillsConfig, { SKILL_TIERS, tierForLevel } from '../../config/SkillsConfig';
import './skills.scss';

const Skills = () => {
    const { t } = useTranslation();

    return (
        <section className="skills" id="skills">
            <div className="home-v-img">
                <div className="container">
                    <div className="row section-separator">
                        <div className="section-title text-center col-sm-12" />
                        <div className="col-sm-12 col-md-6 mx-auto">
                            <div className="skills-inner">
                                <div className="professional-skill" data-aos="fade-up">
                                    <h3>{t('TechnicalSkills')}</h3>
                                    {SKILL_TIERS.map((tier) => {
                                        const skills = SkillsConfig.filter(
                                            (skill) => tierForLevel(skill.level) === tier
                                        );
                                        if (skills.length === 0) return null;

                                        return (
                                            <div className="skill-tier" key={tier}>
                                                <span className="skill-tier-label">
                                                    {t(`SkillTiers.${tier}`)}
                                                </span>
                                                <div className="skill-pills">
                                                    {skills.map((skill) => (
                                                        <Skill
                                                            key={skill.name}
                                                            name={skill.name}
                                                            icon={skill.icon}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Skills;
